window.ReadOnlyController = ObjectBase.extend({
    applyController: function() {

        if (!this.readOnly || !this.controller || (!this.controller.region && !this.controller.container)) {
            return;
        }

        var region = this.controller.region
            ? this.controller.region.$el
            : this.controller.container
            ? $(this.controller.container)
            : null;

        if (!region) {
            return;
        }

        ReadOnlyController.apply(region);
    }

});

ReadOnlyController.apply = function(region) {
    $(":not([react-region]) input,select,button,textarea,a,td", region)
        .each(function() {

            if (region.hasAttr('react-region')) {
                return
            }

            var $this = $(this);
            var readOnlyValue = $this.attr("read-only");

            if (readOnlyValue == "ignore" || $this.hasClass("close")) {
                return;
            }

            if (readOnlyValue == 'hide') {
                $this.hide();
                return;
            }

            if ($this.is('td')) {
                return;
            }

            if ($this.is(":input:not(input[type=button]),textarea")) {
                $this.prop("readonly", true);
                $this.prop("disabled", true);
            }

            if ($this.is(":button,:input[type=button]")  || $this[0].hasAttribute("hide-when-read-only")) {
                $this.hide();
            }

        });
};

ReadOnlyController.applyAll = function() {

    $("[read-only=container]").each(function() {
        ReadOnlyController.apply($(this));
    });

};

$(document)
    .ready(function() {

        ReadOnlyController.applyAll();

        if (ControllerBase.current) {
            ControllerBase.current.applyReadOnly();
        }

    });